export const LOGIN_ICON = "Key-24";
export const PW_RESET_ICON = "Reset-Password-24";
export const APP_ICON = "App-24";
export const FORBID_ICON = "Forbid-16";
